var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.76492V16.79C0 20.7737 3.16614 24 7.07561 24H27.6234C29.0774 24 30.2725 22.7822 30.2725 21.3005V7.24317C30.2725 3.25946 27.1064 0.0332031 23.1969 0.0332031H2.64916C1.19509 0.0332031 0 1.21776 0 2.66621V2.76492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.631 18.3704L38.3168 23.44C39.2213 24.2629 40.6428 24.1642 41.4504 23.2425C41.8062 22.8145 41.9999 22.2877 41.9999 21.7609V2.27138C41.9999 1.02036 40.9986 0.0322528 39.8025 0C39.253 0 38.736 0.197426 38.3485 0.560026L32.6301 5.66281C32.1457 6.09089 31.8867 6.7164 31.8867 7.37514V16.6923C31.8867 17.3178 32.1773 17.9433 32.6301 18.3714L32.631 18.3704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/VideoCall.cbd5090cff6fa1365cc1002adc9ac4f5.svg";
export { ForwardRef as ReactComponent };